import React from 'react';
import styles from './index.module.css';

const UpdatedDate = ({date}) =>
  <div className={styles.container}>
    Data updated {date}
  </div>

export default UpdatedDate;
